import { render, staticRenderFns } from "./BrandSymbol.vue?vue&type=template&id=53544c3d&"
import script from "./BrandSymbol.vue?vue&type=script&lang=js&"
export * from "./BrandSymbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports